import * as Sentry from "@sentry/browser";
import polyfills from "./shared/polyfills";
import { datadogRum } from '@datadog/browser-rum';

// Enable Sentry for non-development environments.
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://34092f8ac62c43f88e47f2b7eb9c8876@sentry.io/1369074", // There is only ever one value for this, it doesn't vary by environment.

    // Purposely filter out __ENVIRONMENT__ and __RELEASE_ENVIRONMENT__ to keep things clean if someone forgets to set a configuration value.
    environment: window.environment && !(["__ENVIRONMENT__", "__RELEASE_ENVIRONMENT__"].find((s) => s === window.environment))
      ? window.environment
      : "dev",

    release: window.sourceVersion || undefined,
  });
}

polyfills();

if (process.env.NODE_ENV !== "development") {
  datadogRum.init({
    applicationId: window.datadogAppId,
    clientToken: window.datadogClientToken,
    env: window.environment,
    sampleRate: 100,
    site: "datadoghq.com",
    trackInteractions: true,
    version: window.buildVersion,
  });
}

const m = module as any;
if (m.hot) {
  m.hot.accept();
}
